(function () {
  'use strict';

  var modalListeners = new WeakMap();
  var openModalCount = 0;
  var previousBodyOverflow = '';
  var previousBodyOverflowPriority = '';

  // Shopify auto-bundles theme JS with esbuild, which rewrites import() → require().
  // Hide dynamic import inside new Function so esbuild can't see it.
  var loadModule = new Function('u', 'return ' + 'import' + '(u)');

  function parseDimensions(strings) {
    var pattern = /(\d{1,3})\s*[x×]\s*(\d{1,3})/i;
    for (var i = 0; i < strings.length; i++) {
      var s = strings[i];
      if (!s) continue;
      var m = s.match(pattern);
      if (m) return { width: parseInt(m[1], 10), height: parseInt(m[2], 10) };
    }
    return { width: 60, height: 60 };
  }

  function detectDevice() {
    var ua = navigator.userAgent;
    var isIOS = /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var isAndroid = /Android/.test(ua);
    return { isIOS: isIOS, isAndroid: isAndroid, isMobile: isIOS || isAndroid };
  }

  function checkWebXrSupport() {
    if (!('xr' in navigator)) return Promise.resolve(false);
    try {
      return navigator.xr.isSessionSupported('immersive-ar').catch(function () { return false; });
    } catch (e) {
      return Promise.resolve(false);
    }
  }

  function qrUrlFor(url) {
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    var deepLink = url + sep + 'ar=launch';
    return 'https://api.qrserver.com/v1/create-qr-code/?size=240x240&margin=8&data=' +
      encodeURIComponent(deepLink);
  }

  function setBody(root, html) {
    root.querySelector('[data-ar-body]').innerHTML = html;
  }

  function openModal(root) {
    var modal = root.querySelector('.ecolor-ar__modal');
    modal.hidden = false;
    if (modalListeners.has(modal)) return;

    var controller = new AbortController();
    modalListeners.set(modal, controller);
    if (openModalCount === 0) {
      previousBodyOverflow = document.body.style.getPropertyValue('overflow');
      previousBodyOverflowPriority = document.body.style.getPropertyPriority('overflow');
    }
    openModalCount += 1;
    document.body.style.overflow = 'hidden';
    var closers = modal.querySelectorAll('[data-ar-close]');
    var close = function () { closeModal(root); };
    for (var i = 0; i < closers.length; i++) {
      closers[i].addEventListener('click', close, { signal: controller.signal });
    }
    var onKey = function (e) {
      if (e.key === 'Escape') {
        closeModal(root);
      }
    };
    document.addEventListener('keydown', onKey, { signal: controller.signal });
  }

  function closeModal(root) {
    var modal = root.querySelector('.ecolor-ar__modal');
    modal.hidden = true;
    var controller = modalListeners.get(modal);
    if (!controller) return;
    controller.abort();
    modalListeners.delete(modal);
    openModalCount -= 1;
    if (openModalCount === 0) {
      document.body.style.setProperty('overflow', previousBodyOverflow, previousBodyOverflowPriority);
    }
  }

  function showQr(root, url, message) {
    setBody(root,
      '<h3 class="ecolor-ar__title">Voir sur ton mobile</h3>' +
      '<p class="ecolor-ar__subtitle">' +
      (message || 'Scanne ce QR code avec l\'appareil photo de ton téléphone — la vue AR de ce carrelage s\'ouvrira automatiquement.') +
      '</p>' +
      '<img class="ecolor-ar__qr-img" src="' + qrUrlFor(url) + '" alt="QR code">'
    );
    openModal(root);
  }

  function showLoading(root, text) {
    setBody(root,
      '<div class="ecolor-ar__loading">' +
      '<div class="ecolor-ar__spinner"></div>' +
      '<p>' + text + '</p>' +
      '</div>'
    );
    openModal(root);
  }

  function showError(root, err) {
    var msg = (err && err.message) ? err.message : 'Erreur inconnue';
    var stack = (err && err.stack) ? String(err.stack).split('\n').slice(0, 4).join('\n') : '';
    var build = 'build:ar-v6-' + (root.dataset.usdzModule || '').split('?v=').pop();
    setBody(root,
      '<div class="ecolor-ar__error">' +
      '<strong>Impossible de lancer l\'AR.</strong>' +
      '<p>' + msg + '</p>' +
      (stack ? '<pre style="text-align:left;font-size:10px;overflow:auto;max-height:120px;background:#f5f5f5;padding:6px;border-radius:4px;margin-top:8px;white-space:pre-wrap">' + escapeHtml(stack) + '</pre>' : '') +
      '<p style="font-size:10px;color:#999;margin-top:8px">' + escapeHtml(build) + '</p>' +
      '</div>'
    );
    openModal(root);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function askSurface(root, data, onPick) {
    setBody(root,
      '<h3 class="ecolor-ar__title">Sur quelle surface ?</h3>' +
      '<p class="ecolor-ar__subtitle">Ce carrelage peut être posé au sol ou au mur. Choisis où tu veux le voir.</p>' +
      '<div class="ecolor-ar__surface-choice">' +
      '<button type="button" class="ecolor-ar__surface-btn" data-surface="floor">Au sol</button>' +
      '<button type="button" class="ecolor-ar__surface-btn ecolor-ar__surface-btn--outline" data-surface="wall">Au mur</button>' +
      '</div>'
    );
    openModal(root);
    var btns = root.querySelectorAll('[data-surface]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        var picked = e.currentTarget.getAttribute('data-surface');
        onPick(picked);
      }, { once: true });
    }
  }

  function launchUsdz(root, data) {
    showLoading(root, 'Préparation de la vue AR…');
    return loadModule(root.dataset.usdzModule)
      .then(function (mod) { return mod.prepareUsdz(data); })
      .then(function (ready) {
        var dbg = ready.debug || {};
        var dbgLine = dbg.tileWidthCm
          ? 'Carrelage détecté : ' + dbg.tileWidthCm + ' × ' + dbg.tileHeightCm + ' cm — ' +
            'surface : ' + dbg.planeW + ' × ' + dbg.planeH + ' m (' + dbg.tilesU + '×' + dbg.tilesV + ' dalles)'
          : '';
        setBody(root,
          '<h3 class="ecolor-ar__title">Prêt à voir le carrelage chez toi</h3>' +
          '<p class="ecolor-ar__subtitle">Tape sur le bouton ci-dessous pour ouvrir la vue en réalité augmentée.</p>' +
          (dbgLine ? '<p style="font-size:11px;color:#888;margin-bottom:0.75rem">' + dbgLine + '</p>' : '') +
          '<a class="ecolor-ar__surface-btn" rel="ar" href="' + ready.href + '" download="' + ready.filename + '" data-ar-launch>' +
            '<img alt="" style="display:none">' +
            'Lancer la vue AR' +
          '</a>'
        );
        var link = root.querySelector('[data-ar-launch]');
        link.addEventListener('click', function () {
          setTimeout(function () {
            ready.cleanup();
            closeModal(root);
          }, 1500);
        }, { once: true });
      })
      .catch(function (err) {
        console.error('[ECOLOR AR / USDZ]', err);
        showError(root, err);
      });
  }

  function launchWebXr(root, data) {
    showLoading(root, 'Démarrage de la caméra AR…');
    return loadModule(root.dataset.webxrModule)
      .then(function (mod) {
        return mod.launchWebXr(data, function () { closeModal(root); });
      })
      .catch(function (err) {
        console.error('[ECOLOR AR / WebXR]', err);
        showError(root, err);
      });
  }

  function handleClick(root) {
    var ds = root.dataset;
    var dims = parseDimensions([ds.variantTitle, ds.productTitle]);
    var data = {
      productTitle: ds.productTitle,
      variantTitle: ds.variantTitle,
      textureUrl: ds.textureUrl,
      surface: ds.surface || 'floor',
      productUrl: ds.productUrl,
      tileWidthCm: dims.width,
      tileHeightCm: dims.height
    };

    var device = detectDevice();

    if (!device.isMobile) {
      return showQr(root, data.productUrl);
    }

    function go(finalSurface) {
      data.surface = finalSurface;
      if (device.isIOS) {
        launchUsdz(root, data);
      } else {
        checkWebXrSupport().then(function (ok) {
          if (ok) {
            launchWebXr(root, data);
          } else {
            showQr(root, data.productUrl,
              'Ton navigateur ne supporte pas WebXR. Scanne ce QR code avec Chrome récent sur Android.');
          }
        });
      }
    }

    if (data.surface === 'both') {
      askSurface(root, data, go);
    } else {
      go(data.surface);
    }
  }

  function init() {
    var roots = document.querySelectorAll('.ecolor-ar');
    for (var i = 0; i < roots.length; i++) {
      (function (root) {
        var btn = root.querySelector('.ecolor-ar__trigger');
        if (!btn) return;
        btn.addEventListener('click', function () { handleClick(root); });
      })(roots[i]);
    }

    autoLaunchFromUrl(roots);
  }

  function autoLaunchFromUrl(roots) {
    if (!roots.length) return;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (params.get('ar') !== 'launch') return;

    params.delete('ar');
    var newSearch = params.toString();
    var newUrl = window.location.pathname +
      (newSearch ? '?' + newSearch : '') +
      window.location.hash;
    try { history.replaceState(null, '', newUrl); } catch (e) { /* ignore */ }

    handleClick(roots[0]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
